import React, {useState, useRef} from 'react'
import {useDispatch, useSelector} from "react-redux";
import {applyHotspotChanges, updateHotspot} from "../../actions";
import AjaxButton from "src/shared/form/ajax_button";
import {
  FormLabel,
  FormControl,
  InputLabel,
  TextField,
  Checkbox,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem
} from "@material-ui/core";
import {ThemeProvider} from '@material-ui/core/styles';
import {crateAccountOrganizationTheme} from 'virtual_congress/components/custom_css'
import FlaveCodeEditor from "../../../flave_code_editor";


export default function DefaultHotspotSettings(props) {
  const {id, visibility_type, data} = props.hotspot
  const dispatch = useDispatch()
  const [selectedHotspotImage, setSelectedHotspotImage] = useState(null);
  const [selectedMobileHotspotImage, setSelectedMobileHotspotImage] = useState(null);
  const [selectedHotspotHoverImage, setSelectedHotspotHoverImage] = useState(null);
  const account = useSelector((state) => state.account)
  const hotspotImageUrl = useSelector((state) => state.hotspotImageUrl)
  const accountOrganization = useSelector(state => state.accountOrganization)
  const [selectOpen, setSelectOpen] = useState(false)
  const labelRef = useRef()
  const labelWidth = labelRef.current ? labelRef.current.clientWidth : 0

  return <div>
    <hr/>
    <div className="form-group">
      <ThemeProvider theme={crateAccountOrganizationTheme(accountOrganization)}>
        <TextField
          label="Title"
          fullWidth={true}
          variant="outlined"
          size="small"
          placeholder="Sets the title for the popup."
          value={data && data.title ? data.title : ""}
          onChange={(event) => {
            dispatch(updateHotspot({
              ...props.hotspot,
              data: {
                ...props.hotspot.data,
                title: event.target.value
              }
            }))
          }}
        />
      </ThemeProvider>
    </div>
    <div className="form-group">
      <ThemeProvider theme={crateAccountOrganizationTheme(accountOrganization)}>
        <TextField
          label="Hotspot Priority"
          type="number"
          fullWidth={true}
          variant="outlined"
          size="small"
          placeholder="Orders hotspots like 50,10,3,2,1 (highest number will be placed on top)"
          value={data?.hotspot_order}
          onChange={(event) => {
            dispatch(updateHotspot({
              ...props.hotspot,
              data: {
                ...props.hotspot.data,
                hotspot_order: event.target.value
              }
            }))
          }}
        />
      </ThemeProvider>
    </div>

    {!["inline_html", "video", "slideshow"].includes(props.hotspot.kind) &&
    <div className="form-group">
      <ThemeProvider theme={crateAccountOrganizationTheme(accountOrganization)}>
        <FormControl size="small" fullWidth={true} variant="outlined">
          <InputLabel ref={labelRef} shrink htmlFor="visibility_type">
            Visibility Type
          </InputLabel>

          <Select
            fullWidth={true}
            labelWidth={labelWidth == 0 ? 123 : labelWidth}
            placeholder="Sets the title for the popup."
            value={props.hotspot.visibility_type}
            onOpen={() => setSelectOpen(true)}
            onClose={() => setSelectOpen(false)}
            onChange={(event) => {
              dispatch(updateHotspot({
                ...props.hotspot,
                visibility_type: event.target.value || "default"
              }))
            }}
          >
            <MenuItem value="default">
              <div className="pr-1" style={{fontSize: "0.9em"}}>
                Default hotspot image
                {selectOpen &&
                <>
                  <br/>
                  <small className="text-muted"
                         style={{fontSize: "0.9em", whiteSpace: "break-spaces", lineHeight: "0.9em"}}>
                    This is the default type which shows a circular icon.
                  </small>
                </>
                }
              </div>
            </MenuItem>
            <MenuItem value="image">
              <div className="pr-1" style={{fontSize: "0.9em"}}>
                Custom hotspot image
                {selectOpen &&
                <>
                  <br/>
                  <small className="text-muted"
                         style={{fontSize: "0.9em", whiteSpace: "break-spaces", lineHeight: "0.9em"}}>
                    This will show an image which you can upload, no image necessary for logo and character areas.
                  </small>
                </>
                }
              </div>
            </MenuItem>
            <MenuItem value="hidden">
              <div className="pr-1" style={{fontSize: "0.9em"}}>
                Transparent area
                {selectOpen &&
                <>
                  <br/>
                  <small className="text-muted"
                         style={{fontSize: "0.9em", whiteSpace: "break-spaces", lineHeight: "0.9em"}}>
                    This will show no icon for the hotspot, only a transparent area.
                  </small>
                </>
                }
              </div>
            </MenuItem>
            {account.backend_permission && <MenuItem value="inline_html">
              <div className="pr-1" style={{fontSize: "0.9em"}}>
                Inline HTML
                {selectOpen &&
                <>
                  <br/>
                  <small className="text-muted"
                         style={{fontSize: "0.9em", whiteSpace: "break-spaces", lineHeight: "0.9em"}}>
                    This will allow you to specify inline html for the hotspot.
                  </small>
                </>
                }
              </div>
            </MenuItem>}

          </Select>
        </FormControl>
      </ThemeProvider>

      {visibility_type === "inline_html" && account.backend_permission && <>
        <div>
          <hr/>
          <h5 className="hotspot-setting-header">Hotspot Inline HTML</h5>
          <div className="hotspot-setting-info">
            Enter html below to display it.
          </div>
          <div className="form-group">
            <FlaveCodeEditor
              value={data.hotspot_inline_html}
              placeholder={`<div role="open-hotspot">Open Hotspot</div>`}
              onChange={(value) => {
                dispatch(updateHotspot({
                  ...props.hotspot,
                  data: {
                    ...props.hotspot.data,
                    hotspot_inline_html: value
                  }
                }))
              }}
            />

            {/*<textarea
                className="form-control"
                placeholder="<iframe .../>"
                value={value}
                onChange={onDataChanged}
            />*/}
          </div>
        </div>
      </>}

      {visibility_type === "image" && <>
        <div className="form-group form-check mt-2">
          <input type="checkbox" className="form-check-input"
                 defaultChecked={props.hotspot.disable_hotspot_animation}
                 onChange={(event) => {
                   console.log("DISABLE HOTSPOT ANIMATION", event.target.checked)
                   dispatch(updateHotspot({
                     ...props.hotspot,
                     disable_hotspot_animation: event.target.checked
                   }))
                 }}/>
          <label htmlFor="" className="form-check-label">
            Disable default hotspot animation
          </label>
        </div>

        {props.hotspot.hotspot_image && props.hotspot.hotspot_image.url && props.hotspot.hotspot_image.url != "" ?
          <img className="img-responsive img-thumbnail mt-2 mb-2" src={props.hotspot.hotspot_image.url}/>
          :
          <>
            <h5 className="hotspot-setting-header mt-2">Hotspot Image</h5>
            <div className="hotspot-setting-info">
              You selected image as visibility type for this hotspot, if not already, you can now upload a image for the
              hotspot.
            </div>
          </>
        }

        <div className="form-group mt-2">
          <div className="custom-file">
            <input type="file"
                   className="custom-file-input"
                   id="download_item_file"
                   accept="image/x-png,image/gif,image/jpeg,image/png"
                   required
                   onChange={e => {
                     dispatch(updateHotspot({
                       ...props.hotspot,
                       hotspot_image: e.target.files[0]
                     }))
                     setSelectedHotspotImage(e.target.files[0])
                   }}
            />

            <label className="custom-file-label"
                   htmlFor="download_item_file">{selectedHotspotImage?.name || "Set a (new) image"}</label>
          </div>
        </div>

        {account.backend_permission && <>
          {props.hotspot.mobile_hotspot_image && props.hotspot.mobile_hotspot_image.url && props.hotspot.mobile_hotspot_image.url != "" &&
          <img className="img-responsive img-thumbnail mt-2 mb-2" src={props.hotspot.mobile_hotspot_image.url}/>
          }
          <div className="form-group mt-2">
            <div className="custom-file">
              <input type="file"
                     className="custom-file-input"
                     id="mobile-hotspot-image"
                     accept="image/x-png,image/gif,image/jpeg,image/png"
                     required
                     onChange={e => {
                       dispatch(updateHotspot({
                         ...props.hotspot,
                         mobile_hotspot_image: e.target.files[0]
                       }))
                       setSelectedMobileHotspotImage(e.target.files[0])
                     }}
              />

              <label className="custom-file-label"
                     htmlFor="download_item_file">{selectedMobileHotspotImage?.name || "Set a (new) mobile image"}</label>
            </div>
          </div>
        </>}
      </>}
    </div>
    }

    <h5 className="hotspot-setting-header pt-2">Hotspot device visibility</h5>
    <div className="hotspot-setting-info">
      Through the hotspot device visibility, you can control on which devices the hotspot is shown.
    </div>
    <select className="form-control"
            id="hotspotType"
            value={data.device_visibility || "both"}
            onChange={(event) => {
              dispatch(updateHotspot({
                ...props.hotspot,
                data: {
                  ...props.hotspot.data,
                  device_visibility: event.target.value,
                }
              }))
            }}
    >
      <option value="both">Mobile & Desktop</option>
      <option value="mobile_only">Mobile</option>
      <option value="desktop_only">Desktop</option>
    </select>

    {!["video", "slideshow"].includes(props.hotspot.kind) && <div className="form-group">
      {props.hotspot.hover_image && props.hotspot.hover_image.url && props.hotspot.hover_image.url != "" &&
      <>
        <hr className="mb-1"/>
        <img className="img-responsive img-thumbnail mt-2 mb-2" src={props.hotspot.hover_image.url}/>
      </>
      }

      <div className="custom-file mt-3">
        <input type="file"
               className="custom-file-input"
               id="download_item_file"
               accept="image/*"
               required
               onChange={e => {
                 dispatch(updateHotspot({
                   ...props.hotspot,
                   hover_image: e.target.files[0]
                 }))
                 setSelectedHotspotHoverImage(e.target.files[0])
               }}
        />

        <label className="custom-file-label"
               htmlFor="download_item_file">{selectedHotspotHoverImage?.name || "Set a hover background image"}</label>
        <div className="hotspot-setting-info">
          Must be 1920px x 1080px, transparency possible
        </div>
      </div>

      {props.hotspot.hover_image && props.hotspot.hover_image.url && props.hotspot.hover_image.url != "" &&
      <>
        <div className="form-group form-check mt-2">
          <input type="checkbox" className="form-check-input"
                 defaultChecked={false}
                 onChange={(event) => {
                   dispatch(updateHotspot({
                     ...props.hotspot,
                     delete_hover_image: event.target.checked
                   }))
                 }}/>
          <label htmlFor="" className="form-check-label">
            Delete background hover image
          </label>
        </div>
      </>
      }
    </div>}
  </div>
}